export default __webpack_public_path__ + "static/media/165.446dd19a.svg";